import Vue from 'vue';
function clone (o){
    return JSON.parse(JSON.stringify(o));
}

module.exports = class Store{
    constructor(obj){
        this.state = new Vue({data:clone(obj)}).$data;
        this.__originalState = obj;
    }
    clearStore(){
        $.extend(this.state,clone(this.__originalState));
    }
}


// WEBPACK FOOTER //
// src/models/Store.js